module.exports = __webpack_public_path__ + "static/eua-123ac36091474e54fcce55c824ee82ed.png";